import React, { useState } from "react";
import Contact from "../contact";
import Testimonials from "../Testimonials";
import arrowIcon from "../../images/home/arrow-icon.svg";
import ellipticalIcon from "../../images/individual/ellipticalIcon.svg";
import rightVector from "../../images/individual/right-vector.svg";
import benifitIcon from "../../images/individual/benifitIcon.png";
import permanentIcon from "../../images/individual/permanent-resident.svg";
import visaImage from "../../images/individual/SC-500--Student-Visa.jpg";
import helpIcon from "../../images/individual/helpIcon.svg";
import helpImage from "../../images/individual/immigetHelp.png";
import { FaPlus, FaTimes, FaWrench, FaGraduationCap, FaDollarSign, FaBriefcase, FaRocket, FaCheckCircle, FaCar, FaHammer, FaTint, FaBolt, FaUtensils, FaHome, FaSnowflake } from "react-icons/fa";
import unlimitedIcon from "../../images/individual/ic_outline-home-work.svg";
import iconPeople from "../../images/individual/akar-icons_people-group.svg";
import materialIcon from "../../images/individual/material-symbols_family-home-outline.svg";
import medicareIcon from "../../images/individual/icon-park-outline_medical-files.svg";
import { Helmet } from "react-helmet-async";

const TradeCourses = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const scrollToContact = () => {
    const contactSection = document.querySelector('#contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Testimonials data for this specific page
  const testimonials = [
    {
      content: "Immiget helped me go from a Certificate III in Carpentry to PR in 3 years!",
      name: "Raj",
      location: "India",
      visaType: "Trade Course to PR Pathway"
    },
    {
      content: "As a chef, I got state nomination within 6 months of graduating.",
      name: "Maria",
      location: "Philippines",
      visaType: "Trade Course to PR Pathway"
    }
  ];

  return (
    <div>
      <Helmet>
        <title>Trade Courses – Your Pathway to Australian PR – Immiget Global</title>
        <meta
          name="description"
          content="Fast-track your Australian PR through trade qualifications. Expert guidance for trade courses leading to skilled migration visas. High success rate with Immiget Global."
        />
      </Helmet>
      
      <div className="w-full h-90 font-Hellix bg-cover bg-center bg-image">
        <div className="max-w-[1440px] px-4 md:px-[75px] m-auto h-full">
          <div className="flex flex-col gap-2 md:gap-2 pt-10 md:pt-20 pb-[90px] h-full justify-center">
            <div className="text-white hellix-font text-center font-semibold text-[22px] md:text-[54px]">
              Trade Courses
            </div>
            <div className="flex justify-center gap-2 md:gap-4">
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium">
                HOME
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                Individual & Families
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                Trade Courses
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Introduction Section */}
      <div className="xl:flex gap-4 justify-center container max-w-1440px mx-auto px-4 py-4 md:py-10 lg:px-14">
        <div className="xl:w-[50%]">
          <h1 className="xl:text-[28px] text-[24px] max-xl:text-center text-blue mt-6 font-semibold hellix-font">
            Trade Courses – Your Pathway to Australian Permanent Residency (PR)
          </h1>
          <p className="max-xl:text-center hellix-font text-blue text-lg xl:text-[20px] font-normal">
            Dreaming of becoming an Australian permanent resident? Completing a trade qualification in Australia can fast-track your PR through skilled migration pathways. At Immiget Global, we help international students and workers leverage trade qualifications for successful PR applications.
          </p>
        </div>
        <div className="xl:w-[50%] max-xl:justify-center max-xl:flex max-xl:mt-4">
          <img src={visaImage} alt="Trade Courses" />
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Why Choose a Trade Course for PR */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            Why Choose a Trade Course for PR?
          </h1>
        </div>
        <div className="flex flex-wrap justify-between mt-8">
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaWrench className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font px-4">
              High-Demand Occupations – Many trades are on the Skilled Occupation List (SOL)
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaRocket className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font px-4">
              Faster PR Pathways – Trade qualifications often lead to TSS (482) or 186 visas
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaDollarSign className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font px-4">
              Lower Study Costs – Trade courses are more affordable than degrees
            </div>
          </div>
        </div>
        <div className="flex gap-8 justify-center flex-wrap mt-8">
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaBriefcase className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg font-normal max-md:px-2 text-center hellix-font">
              Work While You Study – Gain practical experience and income
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaCheckCircle className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg text-center max-md:px-2 font-normal hellix-font">
              Priority Processing – Some trade occupations get faster visa approvals
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Popular PR-Eligible Trade Courses */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            Popular PR-Eligible Trade Courses
          </h1>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
          {[
            { name: "Automotive Electrician", icon: FaCar },
            { name: "Carpenter", icon: FaHammer }, 
            { name: "Plumber", icon: FaTint },
            { name: "Electrician", icon: FaBolt },
            { name: "Chef/Cook", icon: FaUtensils },
            { name: "Bricklayer", icon: FaHome },
            { name: "Air Conditioning Mechanic", icon: FaSnowflake }
          ].map((trade, index) => {
            const IconComponent = trade.icon;
            return (
              <div key={index} className="bg-white shadow-custom-white rounded-lg p-6 text-center">
                <div className="flex justify-center mb-4">
                  <IconComponent className="text-blue text-3xl" />
                </div>
                <h3 className="text-blue text-lg font-semibold hellix-font">
                  {trade.name}
                </h3>
              </div>
            );
          })}
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* How Trade Qualifications Lead to PR */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            How Trade Qualifications Lead to PR
          </h1>
        </div>
        
        <div className="mt-6 space-y-6">
          {/* Step 1 */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-lg font-bold hellix-font">1</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Complete a Recognized Trade Course
              </h3>
            </div>
            <div className="lg:ml-4">
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Certificate III or IV (1-2 years)</span>
              </div>
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Diploma (optional for higher points)</span>
              </div>
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Must include practical training</span>
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-lg font-bold hellix-font">2</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Get Licensed (If Required)
              </h3>
            </div>
            <div className="lg:ml-4">
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Some trades (e.g., electrician, plumber) require state licensing</span>
              </div>
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">We help with skills assessments (TRA, VETASSESS)</span>
              </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-lg font-bold hellix-font">3</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Gain Work Experience
              </h3>
            </div>
            <div className="lg:ml-4">
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">1-3 years post-study work improves PR eligibility</span>
              </div>
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Employer sponsorship (TSS 482 visa) is common</span>
              </div>
            </div>
          </div>

          {/* Step 4 */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-lg font-bold hellix-font">4</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Apply for PR
              </h3>
            </div>
            <div className="lg:ml-4">
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Skilled Nominated Visa (Subclass 190) – State-sponsored</span>
              </div>
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Skilled Work Regional Visa (Subclass 491) – Regional pathway</span>
              </div>
              <div className="flex gap-2">
                <img src={rightVector} alt="" className="min-w-[30px]" />
                <span className="text-blue text-lg hellix-font">Employer Nomination Scheme (Subclass 186) – Direct PR with work experience</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Best States for Trade Migration */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            Best States for Trade Migration
          </h1>
        </div>
        
        <div className="mt-8 overflow-x-auto">
          <table className="w-full bg-white shadow-custom-white rounded-lg overflow-hidden">
            <thead className="bg-blue text-white">
              <tr>
                <th className="p-4 text-left hellix-font font-semibold">State</th>
                <th className="p-4 text-left hellix-font font-semibold">In-Demand Trades</th>
                <th className="p-4 text-left hellix-font font-semibold">PR Pathway</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-gray-200">
                <td className="p-4 text-blue font-semibold hellix-font">NSW</td>
                <td className="p-4 text-blue hellix-font">Electricians, Carpenters</td>
                <td className="p-4 text-blue hellix-font">Subclass 190/491</td>
              </tr>
              <tr className="border-b border-gray-200 bg-gray-50">
                <td className="p-4 text-blue font-semibold hellix-font">VIC</td>
                <td className="p-4 text-blue hellix-font">Plumbers, Chefs</td>
                <td className="p-4 text-blue hellix-font">Subclass 190</td>
              </tr>
              <tr className="border-b border-gray-200">
                <td className="p-4 text-blue font-semibold hellix-font">QLD</td>
                <td className="p-4 text-blue hellix-font">Diesel Mechanics, Bricklayers</td>
                <td className="p-4 text-blue hellix-font">Subclass 491 (Regional)</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="p-4 text-blue font-semibold hellix-font">WA</td>
                <td className="p-4 text-blue hellix-font">Aircon Techs, Welders</td>
                <td className="p-4 text-blue hellix-font">State Nomination</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Why Choose Immiget Global */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            Why Choose Immiget Global?
          </h1>
        </div>
        <div className="text-blue font-normal text-lg lg:text-[20px] mt-2 hellix-font">
          Start Your Trade Journey Today! We provide expert guidance from study to PR.
        </div>
        <div className="lg:ml-4 mt-4">
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>Trade Course & Visa Experts</strong> – We guide you from study to PR
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>High Success Rate</strong> – Proven strategies for trade-based PR
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>Licensing Assistance</strong> – Help with skills assessments (TRA, VETASSESS)
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>Employer Sponsorship Support</strong> – Connect with trade employers
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>PR Application Specialists</strong> – Maximize your points for approval
            </div>
          </div>
        </div>
        
        {/* CTA Button */}
        <div className="mt-6 text-center">
          <button 
            onClick={scrollToContact}
            className="bg-blue text-white px-8 py-3 rounded-lg font-semibold hellix-font hover:bg-blue-700 transition-colors text-lg"
          >
            Book a Free Consultation to Plan Your PR Pathway
          </button>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* How Immiget Will Help You */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={helpIcon} alt="help" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            How Immiget Will Help You?
          </h1>
        </div>
        <div className="text-blue font-normal text-lg lg:text-[20px] mt-2 hellix-font">
          Immiget Global is here to assist at every stage of your trade course to PR journey. Our team provides:
        </div>
        <div className="xl:flex gap-6 mt-4">
          <div className="xl:w-[50%]">
            <img src={helpImage} alt="help" className="h-[100%]" />
          </div>
          <div className="xl:w-[50%] max-xl:mt-4 flex flex-col gap-1">
            <div>
              <ul className="list-inside">
                <li className="text-blue text-lg lg:text-[20px] hellix-font font-semibold">
                  Course Selection Guidance:
                  <span className="font-normal">
                    We help you choose the right trade course based on your PR goals and current skills.
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <ul className="list-inside">
                <li className="text-blue text-lg lg:text-[20px] hellix-font font-semibold">
                  Skills Assessment Support:
                  <span className="font-normal">
                    Our experts assist with TRA and VETASSESS applications for trade qualifications.
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <ul className="list-inside">
                <li className="text-blue text-lg lg:text-[20px] hellix-font font-semibold">
                  Employer Connections:
                  <span className="font-normal">
                    We connect you with trade employers for sponsorship opportunities and work experience.
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <ul className="list-inside">
                <li className="text-blue text-lg lg:text-[20px] hellix-font font-semibold">
                  PR Application Strategy:
                  <span className="font-normal">
                    We develop personalized strategies to maximize your PR application success.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <h1 className="lg:text-[28px] text-2xl text-center text-blue font-semibold hellix-font">
          Trade Courses FAQs
        </h1>
        <p className="text-blue font-normal text-lg lg:text-[20px] text-center hellix-font">
          Get answers to common questions about trade courses and PR pathways.
        </p>

        <div className="accordion-container mt-8">
          {/* FAQ 1 */}
          <div className="accordion">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(1)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                Which trade has the fastest PR pathway?
              </h2>
              {activeIndex === 1 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 1 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Chefs, Electricians, and Carpenters often get quick state nominations.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 2 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(2)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                Can I work while studying a trade course?
              </h2>
              {activeIndex === 2 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 2 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Yes, student visa holders can work 48 hrs/fortnight (unlimited during holidays).
                </p>
              </div>
            )}
          </div>

          {/* FAQ 3 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(3)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                Do I need IELTS for a trade visa?
              </h2>
              {activeIndex === 3 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 3 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Yes, most skilled visas require IELTS 6.0+ (or equivalent).
                </p>
              </div>
            )}
          </div>

          {/* FAQ 4 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(4)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                How long does it take to get PR after a trade course?
              </h2>
              {activeIndex === 4 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 4 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Typically 2-4 years (study + work experience + visa processing).
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Testimonials Section */}
      <Testimonials 
        testimonials={testimonials} 
        title="Success Stories"
      />

      <div id="contact-section">
        <Contact />
      </div>
    </div>
  );
};

export default TradeCourses;